/**
 * Sticky header on scroll
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    this.config = {
      classes: {
        mobile: 'mobile-header',
        desktop: 'desktop-header',
        headerLogo: 'header__logo-image',
      },
    };
    this.$mobileNav = document.querySelector(`.${this.config.classes.mobile}`);
    this.$desktopNav = document.querySelector(`.${this.config.classes.desktop}`);
    this.$logo = document.querySelectorAll(`.${this.config.classes.headerLogo}`);
    this.bindEvents();
  }

  /**
   * Bind Events
   */
  bindEvents() {
    let lastPosition = 0;
    let ticking = false;
    window.addEventListener('scroll', (event) => {
      if (!ticking && lastPosition !== window.pageYOffset) {
        window.requestAnimationFrame(() => {
          this.handleSticky(window.pageYOffset > 0);
          this.handleVisibility(window.pageYOffset < lastPosition && window.pageYOffset > 0);
          lastPosition = window.pageYOffset;
          ticking = false;
        });

        ticking = true;
      }
    });
  }

  /**
   * handles visibility of nav depending on scroll direction
   * @param {boolean} show
   */
  handleVisibility(show) {
    this.handleModifier('show', show);
  }

  /**
   * removes or adds BEM-modifier-classes to mobile- and desktop header
   * @param {string} modifier - css-modifier name
   * @param {boolean} add - add/remove class
   */
  handleModifier(modifier, add) {
    if (add) {
      this.$logo.forEach((logo) => {
        logo.classList.add(`${this.config.classes.headerLogo}--${modifier}`);
      });
      this.$desktopNav.classList.add(`${this.config.classes.desktop}--${modifier}`);
      this.$mobileNav.classList.add(`${this.config.classes.mobile}--${modifier}`);
    } else {
      this.$logo.forEach((logo) => {
        logo.classList.remove(`${this.config.classes.headerLogo}--${modifier}`);
      });
      this.$desktopNav.classList.remove(`${this.config.classes.desktop}--${modifier}`);
      this.$mobileNav.classList.remove(`${this.config.classes.mobile}--${modifier}`);
    }
  }

  /**
   * toggle header stickiness
   * @param {boolean} sticky
   */
  handleSticky(sticky) {
    this.handleModifier('sticky', sticky);
  }
}
